import { render, staticRenderFns } from "./voteItem.vue?vue&type=template&id=4660ae48&scoped=true&"
import script from "./voteItem.vue?vue&type=script&lang=js&"
export * from "./voteItem.vue?vue&type=script&lang=js&"
import style0 from "./voteItem.vue?vue&type=style&index=0&id=4660ae48&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4660ae48",
  null
  
)

export default component.exports